import React, {useState, useEffect} from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import {toTime, toTimeType, timeConverter, isObjectEmpty, uploadCSV, replaceAll, timeConverterSM, toArray} from '../../../../Utils';
import Spinner from '../../../common/generic/Spinner';

const ContainerComp = ({pageState, reportState, csvData, setcsvData}) =>{
    const {database, deleteThis, request, fetchModules, modulesData, modulesReady } = pageState;
    const [processedMarks, setProcessedMarks] = useState({});
    const [markRecords, setMarkRecords] = useState({});
    const {selectedStudents, selectedProgram} = reportState;

    /*
    CSV NOTES
    =========
    There is a big problem when trying to upload more then 1 csv file.  The below system will reset all the data in 
    this component and start it over when when the user clicks save.
    
    Steps
    1) User clicks save in either ProgramReportTableComp or AcitivityReportComp
        1b) openCSVPage() will populate csvData using setcsvData({processStage:'newRequest'});
    2) ViewReportsPage checks to see if the marks have changed (* seems to be called way to many times...)
        2b) setReportType(csvData.reportType);
            setSelectedProgram({...csvData.selectedProgram});
            setSelectedStudents([...csvData.selectedStudents]); 
    3) Start the report
        3a) CSV Step 1: checks if a new request for csv and starts to clear the data
        3b) CSV Step 2: clears the data 
        3c) CSV Step 3: keep checking to see when the data has been cleared
        3d) CSV Step 4: once the data for this component has been reset then start the normal start up process for this comp.
        3e) (The normal Startup starts at CSV Step 1) 
    */

    // CSV Step 4: once the data for this component has been reset then start the normal start up process for this comp.
    // The normal Startup starts at CSV Step 1 
    const tryLoadingCSVStage2 = () => {
        if(!csvData) return;
        if(csvData.processStage === 'clearingData'){
            if(!database['getMadMinuteMarks'] && isObjectEmpty(markRecords) && isObjectEmpty(processedMarks)){
                setcsvData({...csvData, processStage:'clearedData'});
            }
        }
    };
    // CSV Step 3: keep checking to see when the data has been cleared
    useEffect(() =>{tryLoadingCSVStage2();},[database['getMadMinuteMarks']]);
    useEffect(() =>{tryLoadingCSVStage2();},[markRecords]);
    useEffect(() =>{tryLoadingCSVStage2();},[processedMarks]);

    // CSV Step 2: clears the data
    useEffect(() => {
        if(!csvData) return;

        if(csvData.processStage === 'clearingData'){
            deleteThis('getMadMinuteMarks');
            setMarkRecords({});
            setProcessedMarks({});
        }
    },[csvData]);

    // CSV Step 1: checks if a new request for csv and starts to clear the data 
    // Normal Startup Step 1:
    useEffect(() => {
        if(csvData){
            if(csvData.processStage==='newRequest'){
                // csvData.setloadingCSV({...csvData.loadingCSV, MMDay:true});
                setcsvData({...csvData, processStage:'clearingData'});
                return;
            }

            if(csvData.processStage==='clearingData') return;
        }

        if(!isObjectEmpty(markRecords)) return; // already loading

        if(!database['getMadMinuteMarks']){
            let studentQueries = selectedStudents.map(studentRec=>{
                let getMarksQuery={
                    params: studentRec.id,
                    func:'getMadMinuteMarks'            
                };
                return getMarksQuery;
            });

            if(studentQueries.length > 0){
                let counter = 1;
                studentQueries = studentQueries.map((query,i)=>{
                    let prevQuery = (i!=0) ? studentQueries[i-1] : 'undefinded';
                    if(prevQuery !== 'undefinded'){
                        counter++;
                        query.nextRequest = prevQuery;
                    }
                    return query;
                });
                let loadChainedMarks = studentQueries[studentQueries.length-1];
                loadChainedMarks.numQueries = counter;
                setMarkRecords({info:{numStudents:counter,numLoaded:counter}});

                // pass the link list of saved changes into the database
                request(loadChainedMarks); 
            }
            else
                console.log('Nothing to load?');
        }
    });

    // convert database['getMadMinuteMarks'] into setMarkRecords
    // UDATES - when database['getMadMinuteMarks'] changes
    useEffect(() => {
        if(csvData && csvData.processStage !== 'clearedData') return; // don't setup markRecords for csv files without being ready 
        if(isObjectEmpty(markRecords)) return;
        (!pageState.isFetchingModules && !modulesReady) && fetchModules(selectedProgram.id.toLowerCase());
        if(!database['getMadMinuteMarks']) return;
        
        let marks = {};
        let key = 'unavailable';
        let counter = {...markRecords.info};

        if(database['getMadMinuteMarks'].isLoaded) counter.numLoaded--;
        
        marks = {
            isloaded: database['getMadMinuteMarks'].isLoaded,
            data: database['getMadMinuteMarks'].data
        }; 

        if((marks.data) && !isObjectEmpty(marks.data)){
            key = Object.keys(marks.data)[0].split('+')[0];
        }

        setMarkRecords({...markRecords, info:{...counter}, [key]:marks});

    }, [database['getMadMinuteMarks']]); 

    const tryLoadingNow = () => {
        if(isObjectEmpty(markRecords)) return;
        if(!isObjectEmpty(processedMarks)) return;
        if(markRecords.info.numStudents > 0 && markRecords.info.numLoaded > 0) return;

        let reportData = JSON.parse(localStorage.getItem('reportData'));
        let masterLevel = parseInt(reportData.masterLevel)/100;

        //console.log('markRecords',markRecords);
        let studentMarks = selectedStudents.reduce((acc,studentRec)=>{
            let studentID = studentRec.id;
            let studentMarkRecords = markRecords[studentID];
            if(!studentMarkRecords) return acc; // still loading marks
            //console.log('studentMarkRecords.data',studentMarkRecords.data);

            // console.log('studentMarkRecords.data',studentMarkRecords.data);
            let mergedMarks = toArray(studentMarkRecords.data).reduce((markAcc, markRecord)=>{
                let date = markRecord.DayDate;
  
                if(!markAcc[date])
                    markAcc[date] = {
                        ClassID: markRecord.ClassID,
                        Date: markRecord.DayDate,
                        SchoolID: markRecord.ClassID,
                        StudentID: markRecord.ClassID,
                        Drills: 0,
                        Fact: ''
                    };

                    const addMark = (fact, factName) =>{
                        //console.log('markRecord[`${fact}QuestionsRight`]',markRecord,`markRecord[${fact}Drills]`);
                        if(!markAcc[date][fact]){
                            if(markRecord[`${fact}Drills`]){
                                markAcc[date][fact] = {};
                                markAcc[date][fact].Correct = parseInt(markRecord[`${fact}QuestionsRight`]);
                                markAcc[date][fact].Drills = parseInt(markRecord[`${fact}Drills`]);
                                markAcc[date][fact].Mastered = parseInt(markRecord[`${fact}Mastered`]);
                                markAcc[date][fact].Questions = parseInt(markRecord[`${fact}QuestionsAttempted`]);
                                markAcc[date].Drills += parseInt(markRecord[`${fact}Drills`]);
                                markAcc[date].Fact += factName+' ';
                            }
                        }
                        else{
                            if(markRecord[`${fact}Drills`]){
                                markAcc[date][fact].Correct = parseInt(markAcc[date][fact].Correct) + parseInt(markRecord[`${fact}QuestionsRight`]);
                                markAcc[date][fact].Drills = parseInt(markAcc[date][fact].Drills) + parseInt(markRecord[`${fact}Drills`]);
                                markAcc[date][fact].Mastered = parseInt(markAcc[date][fact].Mastered) + parseInt(markRecord[`${fact}Mastered`]);
                                markAcc[date][fact].Questions = parseInt(markAcc[date][fact].Questions) + parseInt(markRecord[`${fact}QuestionsAttempted`]);
                                markAcc[date].Drills += parseInt(markRecord[`${fact}Drills`]);
                                markAcc[date].Fact += factName+' ';
                            }
                        }
                    };

                    addMark('ADD', 'Add');
                    addMark('SUB', 'Sub');
                    addMark('MULT','Mult');
                    addMark('DIV', 'Div');
                return markAcc;
            },{});

            // console.log('mergedMarks',mergedMarks);
            acc[`${studentRec.id}+${studentRec.name}`] = toArray(mergedMarks);
            return acc;
        },{});
        //.sort((a,b) => (a.title.toUpperCase() > b.title.toUpperCase()) ? 1 : (a.title.toUpperCase() < b.title.toUpperCase() ? -1 : 0));
        
        setProcessedMarks(studentMarks);

        if(csvData){
            let newLine = '%0A';
            let csvString = '';
            csvString +=`"Student without marks will not appear in this report"${newLine}`;
            let tableHeaderStr = '"Date","+","-","*","/","Drills"'+newLine;

            Object.keys(studentMarks).forEach((key) => { 
                let headerStr = `${newLine}"${key.split('+')[1]}"${newLine}"${selectedProgram.name}"${newLine}"Report by Day"${newLine}`;
                let tableData  = studentMarks[key];

                csvString += headerStr + tableHeaderStr;
                let studentTotals = {AddMastered:0,SubMastered:0,MultMastered:0,DivMastered:0, Drills:0};
                tableData.forEach((markRec, mark_i) => {
                    const { Mastered: AddMastered } = tableData[mark_i].ADD || 0;
                    const { Mastered: SubMastered } = tableData[mark_i].SUB || 0;
                    const { Mastered: MultMastered } = tableData[mark_i].MULT || 0;
                    const { Mastered: DivMastered } = tableData[mark_i].DIV || 0;
                    const { Date, Drills } = tableData[mark_i];

                    studentTotals.AddMastered += parseInt(AddMastered) || 0;
                    studentTotals.SubMastered += parseInt(SubMastered) || 0;
                    studentTotals.MultMastered += parseInt(MultMastered) || 0;
                    studentTotals.DivMastered += parseInt(DivMastered) || 0;
                    studentTotals.Drills += Drills;

                    let recordStr = `"${timeConverter(parseInt(Date))}","${AddMastered || 0}","${SubMastered || 0}","${MultMastered || 0}","${DivMastered || 0}","${Drills}"${newLine}`;
                    csvString += recordStr;
                });
                let recordStr = `"Totals","${studentTotals.AddMastered || 0}","${studentTotals.SubMastered || 0}","${studentTotals.MultMastered || 0}","${studentTotals.DivMastered || 0}","${studentTotals.Drills}"${newLine}`;
                csvString += recordStr;
            });
            
            let name = '';
            if(Object.keys(studentMarks).length===0){
                window.alert('There are no marks for the student(s) selected');
                csvData.setloadingCSV({...csvData.loadingCSV, MMDay:false});
                return;
            }

            if(Object.keys(studentMarks).length===1)
                name = Object.keys(studentMarks)[0].split('+')[1]+'_';

            let today = new Date();
            today = timeConverterSM(today.getTime());

            uploadCSV(name+'ReportByDay_'+selectedProgram.name+'_'+today,csvString);
            csvData.setloadingCSV({...csvData.loadingCSV, MMDay:false});
        }

        //};
    }; 
    // useEffect(() =>{tryLoadingNow();},[modulesData]);
    useEffect(() =>{tryLoadingNow();},[markRecords]);

    if(csvData) return <></>;
    if(isObjectEmpty(markRecords)) return <> <Spinner/> <center>Loading... ({database['queryCount']}) </center> </>;
    if(markRecords.info.numStudents > 0 && markRecords.info.numLoaded > 0) return <> <Spinner/> <center>Loading... ({database['queryCount']}) </center> </>;

    return <>
        {Object.keys(processedMarks).length < selectedStudents.length && <center> <p>  Students without marks will not appear in this report </p></center>}
        {Object.keys(processedMarks).map((key, i) => (
            <span key={i}><br/> 
            <ReportByDayComp header={{student: key.split('+')[1], program: selectedProgram.name}} tableData={processedMarks[key]}/>            
            <br/></span>
        ))}
    </>;
};

const ReportByDayComp = ({header, tableData}) => {
    //console.log('tableData',tableData);
    const [masterLevel, setMasterLevel] = useState(0.8);
    const [totals, setTotals] = useState({AddMastered:0, SubMastered:0, MultMastered:0, DivMastered:0, Drills:0, isSet: false});

    useEffect(()=>{
        let reportData = JSON.parse(localStorage.getItem('reportData'));
        if(masterLevel !== (parseInt(reportData.masterLevel)/100))
            setMasterLevel(parseInt(reportData.masterLevel)/100);
    });

    useEffect(()=>{
        if(totals.isSet) return;

        tableData.map((markRec) => {
            totals.AddMastered += markRec.ADD ? parseInt(markRec.ADD.Mastered) : 0;
            totals.SubMastered += markRec.SUB ? parseInt(markRec.SUB.Mastered) : 0;
            totals.MultMastered += markRec.MULT ? parseInt(markRec.MULT.Mastered) : 0;
            totals.DivMastered += markRec.DIV ? parseInt(markRec.DIV.Mastered) : 0;
            totals.Drills += parseInt(markRec.Drills) || 0;
        });

        totals.isSet = true;
        
        setTotals({...totals});
    });
    
    const titleRow = <Row style={{ fontSize:'0.9em', fontWeight:'bold'}}>
    <Col xs='12'><Row>
        <Col style={{textAlign: 'left'}} xs='4'> Date </Col>
        <Col style={{textAlign: 'center'}} xs='1'>+</Col>
        <Col style={{textAlign: 'center'}} xs='1'>-</Col>
        <Col style={{textAlign: 'center'}} xs='1'>*</Col>
        <Col style={{textAlign: 'center'}} xs='1'>/</Col>
        <Col style={{textAlign: 'center'}} xs='4'>Drills</Col>
        </Row></Col>
    </Row>;

    const headerComp = <center>
        <h4><Row>
            <Col xs='4'>{header.student}</Col> 
            <Col xs='4'>{header.program} </Col>
            <Col xs='4'>Report By Day</Col>
        </Row></h4>
    </center>;

    const Footer = ()=> <center><hr/></center>;

    return (
        <>
            {headerComp}
            <hr/>
            <Row style={{textAlign:'center', fontSize:'0.9em', fontWeight:'bold'}} >
                <Col xs='4'></Col>
                <Col xs='4'>Mastered Facts</Col>
            </Row>

            {titleRow}
            {tableData.map((markRec, mark_i) => 
                <TableRow key={mark_i} data={markRec} fontWeight={'normal'}/>
            )}

            <Row style={{fontSize:'0.9em',fontWeight: 'bold'}}>        
                <Col style={{textAlign: 'left'}} xs='4'> </Col>
                <Col style={{textAlign: 'center'}} xs='1'>{totals.AddMastered}</Col>
                <Col style={{textAlign: 'center'}} xs='1'>{totals.SubMastered}</Col>
                <Col style={{textAlign: 'center'}} xs='1'>{totals.MultMastered}</Col>
                <Col style={{textAlign: 'center'}} xs='1'>{totals.DivMastered}</Col>
                <Col style={{textAlign: 'center'}} xs='4'>{totals.Drills}</Col>
            </Row>

            <Footer/>
        </>
    );
};
ReportByDayComp.propTypes = {
    tableData: PropTypes.array
};

const TableRow = ({data}) => {
    const { StudentID, ClassID, SchoolID, Date, Drills, Questions, Accuracy, Fact } = data;
    const { Mastered: AddMastered } = data.ADD || 0;
    const { Mastered: SubMastered } = data.SUB || 0;
    const { Mastered: MultMastered } = data.MULT || 0;
    const { Mastered: DivMastered } = data.DIV || 0;
    
    return (
        <Row style={{fontSize:'0.9em'}}>        
            <Col style={{textAlign: 'left'}} xs='4'> {timeConverter(parseInt(Date))} </Col>
            <Col style={{textAlign: 'center'}} xs='1'>{AddMastered || '0'}</Col>
            <Col style={{textAlign: 'center'}} xs='1'>{SubMastered || '0'}</Col>
            <Col style={{textAlign: 'center'}} xs='1'>{MultMastered || '0'}</Col>
            <Col style={{textAlign: 'center'}} xs='1'>{DivMastered || '0'}</Col>
            <Col style={{textAlign: 'center'}} xs='4'>{Drills || '0'}</Col>
        </Row>
    );
};

TableRow.propTypes = {
    fontWeight: PropTypes.string,
    data: PropTypes.object
};

export default ContainerComp;